import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're0014',
    ecrans: ['00-2']
});
